import { Component, Input, OnDestroy } from "@angular/core";

@Component({
  selector: "app-save-button",
  templateUrl: "./save-button.component.html",
  styleUrls: ["./save-button.component.scss"]
})
export class SaveButtonComponent implements OnDestroy {

  @Input() contentBtn = "Save";
  @Input() shortContentBtn?: string;
  @Input() disabled = false;

  constructor() {}

  public setDisabledAttribute(value: boolean): void {
    this.disabled = value;
  }

  ngOnDestroy(): void {
    this.disabled = false;
  }
}
